import { PentestType } from '../enums';

export interface Template {
  id: string;
  opType: PentestType;
  name: string;
}

export namespace Template {
  export function mapFromApiValue(template: any): Template {
    const { id, opType, name } = template;
    return {
      id,
      opType: PentestType.mapFromApiValue(opType),
      name,
    };
  }
}
